class KlaviyoNotifyPopup extends HTMLElement {
  static observedAttributes = ["variant"];
  constructor() {
    super();
  }
  open() {
    this.classList.add("active");
  }
  close() {
    this.classList.remove("active");
  }
  reset() {
    const content = this.querySelector(".klaviyo-content");
    const success = this.querySelector(".klaviyo-success");
    const error = this.querySelector(".klaviyo-error");
    success.classList.add("hidden");
    error.classList.add("hidden");
    content.classList.remove("hidden");
  }
  successCallback(result) {
    const content = this.querySelector(".klaviyo-content");
    const success = this.querySelector(".klaviyo-success");
    content.classList.add("hidden");
    success.classList.remove("hidden");
  }
  errorCallback(error) {
    const content = this.querySelector(".klaviyo-content");
    const error_display = this.querySelector(".klaviyo-error");
    content.classList.add("hidden");
    error_display.classList.remove("hidden");
  }
  submit(email, variant, company) {
    const that = this;
    const payload = {
      data: {
        type: "back-in-stock-subscription",
        attributes: {
          profile: {
            data: {
              type: "profile",
              attributes: {
                email: `${email}`,
              },
            },
          },
          channels: ["EMAIL"],
        },
        relationships: {
          variant: {
            data: {
              type: "catalog-variant",
              id: `$shopify:::$default:::${variant}`,
            },
          },
        },
      },
    };
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        revision: "2024-06-15",
      },
      body: JSON.stringify(payload),
    };
    fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${company}`, options)
      .then((result) => that.successCallback(result))
      .catch((error) => that.errorCallback(error));
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if(name === 'variant' && oldValue !== newValue){
      this.reset();
    }
  }
  connectedCallback() {
    this.companyId = this.hasAttribute("company") ? this.getAttribute("company") : null;
    this.emailInput = this.querySelector("#klaviyo-email-input");
    this.submitButton = this.querySelector(".klaviyo-email-submit");
    this.closeButton = this.querySelector(".klaviyo-close");
    this.content = this.querySelector(".klaviyo-popup-card");
    this.addEventListener("click", (event) => {
      if (!this.content.contains(event.target)) {
        this.close();
      }
    });
    if (!!this.closeButton) {
      this.closeButton.addEventListener("click", (event) => {
        this.close();
      });
    }
    if (!!this.emailInput && !!this.submitButton) {
      this.submitButton.addEventListener("click", (event) => {
        this.variantId = this.hasAttribute("variant") ? this.getAttribute("variant") : null;
        if (this.emailInput.validity.valid) {
          const email = this.emailInput.value;
          if (!!email) {
            this.submit(email, this.variantId, this.companyId);
          }
        } else {
          alert("Email invalid");
        }
      });
    }
  }
}
customElements.define("klaviyo-notify-popup", KlaviyoNotifyPopup);

class KlaviyoNotifyButton extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const popup_id = !!this.getAttribute("for") ? this.getAttribute("for") : null;
    this.popup = document.querySelector(`#${popup_id}`);
    this.addEventListener("click", (event) => {
      event.stopPropagation();
      event.preventDefault();
      if(this.hasAttribute('variant')){
        this.variant = this.getAttribute('variant');
      } else {
        this.variant = this.closest('form[action*="cart/add"]')?.querySelector('[name="id"]')?.value;
      }
      if(this.variant){
        this.popup.setAttribute('variant', this.variant);
      }
      this.popup.open();
    });
  }
}
customElements.define("klaviyo-notify-button", KlaviyoNotifyButton);